module.exports = __webpack_public_path__ + "img/1-2_m-title.5768e6e7.gif";